<div class="card custom-card container_global">
    <div class="flex justify-between card-row">
        <div class="flex card-flex" *ngIf="!isClient"
            [ngClass]="{'card-fifty': !newAnalytic.alias || newAnalytic.alias == 'Ausência de Movimento' || newAnalytic.alias == 'Abandono de Posto' ||
                        newAnalytic.alias == 'Detecção de Emboscada' || newAnalytic.alias == 'Movimento' || newAnalytic.alias == 'Detecção de Capacete' ||
                        newAnalytic.alias == 'Detecção de Máscara'}">
            <div class="card">
                <div class="card-header card-config-analy">
                    <div class="container_tooltip_infor">
                        <span class="need_help tooltip_without_flag">
                            <span class="tooltiptexthelp">Modo de configuração
                                <i nz-icon nzType="info-circle" nzTheme="outline"
                                nz-popover [nzPopoverContent]="popoverContent"></i>
                            </span>
                        </span>
                        <ng-template #popoverContent>
                            <span class="tooltiptextblack">Em teste</span>
                            <br>
                            <span class="tooltiptextsoft">No modo de teste, os alertas gerados chegam para o parceiro, e não 
                                para o cliente.</span>
                            <br><br>
                            <span class="tooltiptextblack">Ativo</span>
                            <br>
                            <span class="tooltiptextsoft">No modo ativo, 
                                os alertas gerados chegam apenas para o cliente.</span>
                            <br>
                        </ng-template>
                    </div>
                    <nz-radio-group [formControl]="testOption" class="radio-group-position" [ngClass]="{'radio-group-after': newAnalytic.alias}">
                        <label nz-radio class="radio-button-mask" [nzValue]="2">Em teste</label>
                        <label nz-radio class="radio-button-mask" [nzValue]="1">Ativo</label>
                    </nz-radio-group>
                </div>
            </div>
        </div>
        <div class="card-flex aglomeration-max card-info"
            [ngClass]="{
                'card-full': isClient && (!newAnalytic.alias || newAnalytic.alias === 'Detecção de Emboscada'),
                'card-fifty': (
                isClient 
                    ? (
                        extraInformation(true) || 
                        newAnalytic.alias === 'Assalto com Moto' || 
                        newAnalytic.alias === 'Detecção de Arma' || 
                        newAnalytic.alias === 'Detecção de Violência' || 
                        newAnalytic.alias === 'Detecção de Queda'
                    ) 
                    : (
                        !newAnalytic.alias || 
                        newAnalytic.alias === 'Ausência de Movimento' || 
                        newAnalytic.alias === 'Abandono de Posto' || 
                        newAnalytic.alias === 'Detecção de Emboscada' ||
                        newAnalytic.alias == 'Detecção de Capacete' ||
                        newAnalytic.alias == 'Detecção de Máscara' ||
                        newAnalytic.alias == 'Movimento'
                    )
                )
            }">
            <div class="card">
                <div class="card-header card-config-analy">
                    <!-- Selecionar Tipo de Analíticos -->
                    <div class="row containerTitle">
                        <span class="TitleInterval">Detecção inteligente</span>
                    </div>
                    <app-filter [list]="typeListSimple" type="simple" placeholder="Selecionar..." [analytic]="true"
                        (filterStatusChange)="selectAnalytic($event)" [showSelected]="true" [styles]="['simple-alternate-style']"
                        [hasIconPrefix]="false" [hasToggle]="true" [selected]="selectedTypeAnalytic"></app-filter>
                </div>
            </div>
        </div>
        <div class="flex card-flex" *ngIf="newAnalytic.alias"
            [hidden]="(newAnalytic.alias == 'Assalto com Moto' || newAnalytic.alias == 'Detecção de Arma' || 
                    newAnalytic.alias == 'Detecção de Violência' || newAnalytic.alias == 'Detecção de Queda'  || newAnalytic.alias == 'Abandono de Posto'
                    || newAnalytic.alias == 'Ausência de Movimento' || newAnalytic.alias == 'Vadiagem' || newAnalytic.alias == 'Detecção de Emboscada' ||
                    (!isClient && (newAnalytic.alias == 'Ausência de Movimento' || newAnalytic.alias == 'Abandono de Posto' || newAnalytic.alias == 'Detecção de Máscara' ||
                    newAnalytic.alias == 'Detecção de Emboscada' || newAnalytic.alias == 'Movimento' || newAnalytic.alias == 'Detecção de Capacete')))"
            [ngClass]="{'card-fifty': isClient && newAnalytic.alias && extraInformation()}">
            <div class="card" *ngIf="showClasses()">
                <div class="container_title_top">
                    <span class="title_for_classification title_for_classification_what">O que deseja detectar:</span>
                </div>
                <div style="flex-wrap: wrap; margin: 2px 6px 10px;" class="container_for_tags" *ngIf="!loadingClass; else loadingclass"
                    [formControl]="selectClassifiers" name="classifier" ngDefaultControl>
                    <div (click)="choiceObjetcs(classifiers)" [id]="classifiers['alias']" class="col border_style tags"
                        *ngFor="let classifiers of optionsClassifiers"
                        [ngClass]="{'border_style_active' : upClassifiers.includes(classifiers['alias'])}">
                        <span class="classification_tags">{{classifiers.alias}}</span>
                    </div>
                </div>
                <ng-template #loadingclass>
                    <span class="loading-central" nz-icon nzType="loading" nzTheme="outline" style="font-size: 36px"></span>
                </ng-template>
            </div>
            <div class="card" *ngIf="newAnalytic.alias === 'Tampering'">
                <div class="card-header card-config-analy">
                    <div class="row containerTitle">
                        <span class="TitleInterval">Tipo de análise</span>
                    </div>
                    <app-filter [list]="selectAnalytics.value.events" type="simple" placeholder="Selecione aqui..."
                                (filterStatusChange)="selectAnalyticEvents($event)" [showSelected]="true" [styles]="['simple-alternate-style']"
                                [hasIconPrefix]="false" [hasToggle]="true" [selected]="selectedEventsAnalytics"></app-filter>
                </div>
            </div>
            <div class="card"  *ngIf="isClient && newAnalytic.alias === 'Detecção de Máscara'">
                <div class="card-header">
                    <div class="style-title-alertas" style="margin-left: 0%;">
                        <label class="mask-label">Alertar quando estiver:</label>
                    </div>
                    <nz-radio-group [formControl]="checkOption" class="radio-group-after">
                        <label nz-radio class="radio-button-mask" (click)="this.newAnalytic.events = ['notmask']" [nzValue]="true">Sem a máscara</label>
                        <label nz-radio class="radio-button-mask" (click)="this.newAnalytic.events = ['mask']" [nzValue]="false">Com a máscara</label>
                    </nz-radio-group>
                </div>
            </div>
            <div class="card" *ngIf="isClient && newAnalytic.alias === 'Detecção de Capacete'">
                <div class="card-header">
                    <div class="style-title-alertas" style="margin-left: 0%;">
                        <label class="mask-label">Alertar quando estiver:</label>
                    </div>
                    <nz-radio-group [formControl]="checkOption" class="radio-group-after">
                        <label nz-radio class="radio-button-mask" (click)="this.newAnalytic.events = ['nothelmet']" [nzValue]="true">Sem capacete</label>
                        <label nz-radio class="radio-button-mask" (click)="this.newAnalytic.events = ['helmet']" [nzValue]="false">Com capacete</label>
                    </nz-radio-group>
                </div>
            </div>
        </div>
        <div *ngIf="newAnalytic.alias === 'Vadiagem'" class="card-flex card-info" [ngClass]="{'card-fifty': isClient}">
            <div class="card">
                <div class="card-header card-config-analy">
                    <div class="row containerTitle" style="margin-top: 0px;">
                        <span class="TitleInterval">Categoria de ocorrências</span>
                    </div>
                    <nz-select [formControl]="loiteringControl" nzPlaceHolder="Selecionar..." class="analytic-alias">
                        <nz-option *ngFor="let loitering of loiterings"
                            [nzValue]="loitering" [nzLabel]="loitering.viewValue"></nz-option>
                    </nz-select>
                </div>
            </div>
        </div>
        <div *ngIf="isClient && (newAnalytic.alias == 'Ausência de Movimento' || newAnalytic.alias == 'Abandono de Posto')"
             class="card-flex criticality-card card-info">
            <div class="card small-card">
                <div class="card-header card-config-analy" style="align-self: flex-start;">
                    <span class="TitleInterval">Alertar a partir de</span>
                    <div class="input-time">
                        <div class="flex mb-2 min">
                            <input class="style-input-time input-max-time" type="text"
                            [formControl]="crowdingMaxTimeMin" mask="s0" placeholder="0">
                            <span class="style-title-alertas time-label">Min</span>
                        </div>
                        <div class="flex sec">
                            <input class="style-input-time input-max-time" type="text"
                            [formControl]="crowdingMaxTimeSec" mask="s0" placeholder="0">
                            <span class="style-title-alertas time-label">Seg</span>
                        </div>
                        <mat-error *ngIf="crowdingMaxTimeMin.value == 0 && crowdingMaxTimeSec.value == 0
                            && (crowdingMaxTimeMin.touched || crowdingMaxTimeSec.touched)"
                            style="color: var(--error-red)">
                                Defina um valor <strong>maior que zero</strong>
                        </mat-error>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-flex criticality-card card-info"
            *ngIf="isClient ? newAnalytic.alias == 'Ausência de Movimento' || newAnalytic.alias && !extraInformation() :
                (newAnalytic.alias == 'Assalto com Moto' || newAnalytic.alias == 'Detecção de Arma' || 
                newAnalytic.alias == 'Detecção de Violência' || newAnalytic.alias == 'Detecção de Queda' )"
            [ngClass]="{'card-fifty': isClient && (newAnalytic.alias == 'Assalto com Moto' || newAnalytic.alias == 'Detecção de Arma' || 
                        newAnalytic.alias == 'Detecção de Violência' || newAnalytic.alias == 'Detecção de Queda' )}">
        <div class="card">
            <div class="card-header card-config-analy">
                <div class="row containerTitle">
                    <span class="TitleInterval">Criticidade do alerta</span>
                </div>
                <app-filter [list]="criticalityOptions" type="simple" placeholder="Selecione aqui..."
                    (filterStatusChange)="changeCriticalityFilter($event)" [showSelected]="true" [analytic]="true"
                    [styles]="['simple-alternate-style']" [hasIconPrefix]="false" [hasToggle]="true" [selected]="criticalitySelected">
                </app-filter>
            </div>
        </div>
</div>
    </div>
    <!-- INFORMAÇÕES EXTRA -->
    <div *ngIf="extraInformation()" class="row card-row">
        <div class="card-info extra-info">
            <div class="card_analitics_agglomeration">
                <!-- Referen te apenas a aglomeração -->
                <div class="flex justify-between" style="margin: 0;">
                    <div *ngIf="newAnalytic.alias === 'Dispersão' || newAnalytic.alias === 'Aglomeração e dispersão'"
                        class="card-flex aglomeration-max card-info" [ngClass]="{'card-fifty': newAnalytic.alias === 'Aglomeração e dispersão'}">
                        <div class="card small-card">
                            <div class="card-header card-config-analy">
                                <span class="style-title-alertas">Mínimo de objetos</span>
                                <div class="flex items-center" style="margin-top: 8px;">
                                    <input class="style-input-time input-max-time" type="number" placeholder="0"
                                        [formControl]="crowdingMinPeople" maxlength="3" min="1" oninput="this.value = Math.abs(this.value.slice(0, this.maxLength))">
                                    <span class="style-input-time label-input">Objeto (s)</span>
                            </div>
                            <mat-error *ngIf="!crowdingMinPeople.valid && crowdingMinPeople.touched" style="color: var(--error-red)">
                                Defina um valor <strong>maior que zero</strong>
                            </mat-error>
                        </div>
                        </div>
                    </div>
                    <div *ngIf="newAnalytic.alias === 'Aglomeração' || newAnalytic.alias === 'Aglomeração e dispersão'"
                        class="card-flex aglomeration-max" [ngClass]="{'card-fifty': newAnalytic.alias === 'Aglomeração e dispersão'}">
                        <div class="card small-card">
                            <div class="card-header card-config-analy">
                                <span class="style-title-alertas">Máximo de objetos</span>
                                <div class="flex items-center" style="margin-top: 8px;">
                                    <input class="style-input-time input-max-time" type="number" placeholder="0"
                                        [formControl]="crowdingMaxPeople" maxlength="3" min="1" oninput="this.value = Math.abs(this.value.slice(0, this.maxLength))">
                                    <span class="style-input-time label-input">Objeto (s)</span>
                                </div>
                                <mat-error *ngIf="!crowdingMaxPeople.valid && crowdingMaxPeople.touched" style="color: var(--error-red)">
                                    Defina um valor <strong>maior que zero</strong>
                                </mat-error>
                            </div>
                        </div>
                    </div>
                    <!--Caso seja analítico de Cruzamento de Linha-->
                    <div *ngIf="newAnalytic.alias === 'Tampering'" class="card-flex card-info">
                        <div class="card">
                            <div class="card-header card-config-analy">
                                <div class="row containerTitle" style="margin-top: 0px;">
                                    <span class="TitleInterval">Nível de corrupção</span>
                                </div>
                                <div class="row containerTitle">
                                    <span class="percentageTitle">{{formatterCorruptionTampergin()}}</span>
                                </div>
                                <nz-slider [nzTipFormatter]="null" (nzOnAfterChange)="validateFormFullInformation($event)"
                                        [(ngModel)]="dissimilarity" [nzMarks]="marks"></nz-slider>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="newAnalytic.alias !== 'Detecção de Emboscada' && newAnalytic.alias !== 'Vadiagem' &&
                                newAnalytic.alias !== 'Cruzamento de Linha' && newAnalytic.alias !== 'Movimento' &&
                                newAnalytic.alias != 'Detecção de Capacete' && newAnalytic.alias != 'Detecção de Máscara'"
                    [hidden]="(isClient && newAnalytic.alias == 'Ausência de Movimento') || newAnalytic.alias == 'Aglomeração e dispersão'"
                        class="card-flex aglomeration-max card-info"
                        [ngClass]="{'card-fifty': newAnalytic.alias == 'Abuso de Permanência' || (!isClient && (newAnalytic.alias == 'Ausência de Movimento' || newAnalytic.alias == 'Abandono de Posto'))}">
                        <div class="card small-card">
                            <div class="card-header card-config-analy">
                                <span class="TitleInterval">Alertar a partir de</span>
                                <div class="input-time" [ngStyle]="{'flex-direction': newAnalytic.alias == 'Abuso de Permanência' ||
                                    (!isClient && (newAnalytic.alias == 'Ausência de Movimento' || newAnalytic.alias == 'Abandono de Posto')) ? 'row' : ''}">
                                    <div class="flex mb-2 min">
                                        <input class="style-input-time input-max-time" type="text"
                                        [formControl]="crowdingMaxTimeMin" mask="s0" placeholder="0">
                                        <span class="style-title-alertas time-label">Min</span>
                                    </div>
                                    <div class="flex sec">
                                        <input class="style-input-time input-max-time" type="text"
                                        [formControl]="crowdingMaxTimeSec" mask="s0" placeholder="0">
                                        <span class="style-title-alertas time-label">Seg</span>
                                    </div>
                                </div>
                                <mat-error *ngIf="crowdingMaxTimeMin.value == 0 && crowdingMaxTimeSec.value == 0
                                && (crowdingMaxTimeMin.touched || crowdingMaxTimeSec.touched)"
                                style="color: var(--error-red)">
                                    Defina um valor <strong>maior que zero</strong>
                                </mat-error>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="newAnalytic.alias === 'Vadiagem'"
                        class="card-fifty aglomeration-max card-info">
                        <div class="card small-card">
                            <div class="card-header card-config-analy">
                                <span class="TitleInterval">Tempo de tolerância</span>
                                <div class="input-time" style="flex-direction: row;">
                                    <div class="flex min">
                                        <input class="style-input-time input-max-time" type="text"
                                                [formControl]="crowdingMaxTimeMin" mask="s0" placeholder="0">
                                        <span class="style-title-alertas time-label">Min</span>
                                    </div>
                                    <div class="flex sec">
                                        <input class="style-input-time input-max-time" type="text"
                                                [formControl]="crowdingMaxTimeSec" mask="s0" placeholder="0">
                                        <span class="style-title-alertas time-label">Seg</span>
                                    </div>
                                </div>
                                <mat-error *ngIf="crowdingMaxTimeMin.value == 0 && crowdingMaxTimeSec.value == 0
                                && (crowdingMaxTimeMin.touched || crowdingMaxTimeSec.touched)"
                                style="color: var(--error-red)">
                                    Defina um valor <strong>maior que zero</strong>
                                </mat-error>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="newAnalytic.alias === 'Detecção de Emboscada'"
                        class="card-flex card-info">
                        <div class="card">
                            <div class="card-header card-config-analy">
                                <div class="row">
                                    <span class="style-title-alertas">Tempo de espera</span>
                                    <div class="input-time" style="flex-direction: row;">
                                        <input class="style-input-time input-max-time" type="text"
                                            [formControl]="crowdingMaxTimeMin" mask="s0">
                                        <span class="style-title-alertas time-label">Minutos</span>
                                    </div>
                                    <mat-error *ngIf="crowdingMaxTimeMin.value == 0 && crowdingMaxTimeMin.touched" style="color: var(--error-red)">
                                        Defina um valor <strong>maior que zero</strong>
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="newAnalytic.alias === 'Detecção de Emboscada'"
                        class="card-flex card-info">
                        <div class="card">
                            <div class="card-header card-config-analy">
                                <div class="row">
                                    <span class="style-title-alertas">Tempo limite</span>
                                    <div class="input-time" style="flex-direction: row;">
                                        <input class="style-input-time input-max-time" type="text"
                                            [formControl]="toleranceTimeMin" mask="s0">
                                        <span class="style-title-alertas time-label">Minutos</span>
                                    </div>
                                    <mat-error *ngIf="!toleranceTimeMin.valid && toleranceTimeMin.touched" style="color: var(--error-red)">
                                        Defina um valor <strong>maior que zero</strong>
                                    </mat-error>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Caso seja analítico de Cruzamento de Linha-->
                    <div *ngIf="newAnalytic.alias === 'Cruzamento de Linha'"
                        class="card-fifty card-info">
                        <div class="card">
                            <div class="card-header card-config-analy">
                                <div class="row containerTitle" style="margin-top: 0px;">
                                    <span class="TitleInterval">Direção do cruzamento</span>
                                </div>
                                <app-filter [list]="selectAnalytics.value.events" type="simple" placeholder="Selecione aqui..."
                                    (filterStatusChange)="selectAnalyticEvents($event)" [showSelected]="true" [styles]="['simple-alternate-style']"
                                    [hasIconPrefix]="false" [hasToggle]="true" [selected]="selectedEventsAnalytics"></app-filter>
                            </div>
                        </div>
                    </div>
                    <div class="card card-flex" *ngIf="newAnalytic.alias === 'Detecção de Máscara'" [ngClass]="{'card-fifty': !isClient}">
                        <div class="card-header">
                            <div class="style-title-alertas" style="margin-left: 0%;">
                                <label class="mask-label">Alertar quando estiver:</label>
                            </div>
                            <nz-radio-group [formControl]="checkOption" class="radio-group-after">
                                <label nz-radio class="radio-button-mask" (click)="this.newAnalytic.events = ['notmask']" [nzValue]="true">Sem a máscara</label>
                                <label nz-radio class="radio-button-mask" (click)="this.newAnalytic.events = ['mask']" [nzValue]="false">Com a máscara</label>
                            </nz-radio-group>
                        </div>
                    </div>
                    <div class="card card-flex" *ngIf="newAnalytic.alias === 'Detecção de Capacete'" [ngClass]="{'card-fifty': !isClient}">
                        <div class="card-header">
                            <div class="style-title-alertas" style="margin-left: 0%;">
                                <label class="mask-label">Alertar quando estiver:</label>
                            </div>
                            <nz-radio-group [formControl]="checkOption" class="radio-group-after">
                                <label nz-radio class="radio-button-mask" (click)="this.newAnalytic.events = ['nothelmet']" [nzValue]="true">Sem capacete</label>
                                <label nz-radio class="radio-button-mask" (click)="this.newAnalytic.events = ['helmet']" [nzValue]="false">Com capacete</label>
                            </nz-radio-group>
                        </div>
                    </div>
                    <div class="card card-flex" *ngIf="newAnalytic.alias == 'Movimento'" [ngClass]="{'card-fifty': !isClient}">
                        <div class="card-header card-config-analy">
                            <div class="container_title_top">
                                <span class="TitleInterval">O que deseja detectar:</span>
                            </div>
                            <div class="container_for_tags" *ngIf="!loadingClass; else loadingclass"
                                [formControl]="selectClassifiers" name="classifier" ngDefaultControl>
                                <div (click)="choiceObjetcs(classifiers)" [id]="classifiers['alias']" class="col border_style tags"
                                    *ngFor="let classifiers of optionsClassifiers"
                                    [ngClass]="{'border_style_active' : upClassifiers.includes(classifiers['alias'])}">
                                    <span class="classification_tags">{{classifiers.alias}}</span>
                                </div>
                            </div>
                            <ng-template #loadingclass>
                                <span class="loading-central" nz-icon nzType="loading" nzTheme="outline" style="font-size: 36px"></span>
                            </ng-template>
                        </div>
                    </div>
                    <div class="card-flex criticality-card card-info" [hidden]="(isClient && newAnalytic.alias == 'Ausência de Movimento') || newAnalytic.alias == 'Aglomeração e dispersão'"
                        [ngClass]="{'card-fifty': newAnalytic.alias === 'Cruzamento de Linha' || newAnalytic.alias == 'Abuso de Permanência' || newAnalytic.alias === 'Vadiagem' || 
                                    (!isClient && (newAnalytic.alias == 'Ausência de Movimento' || newAnalytic.alias == 'Abandono de Posto' || newAnalytic.alias == 'Movimento'||
                                    newAnalytic.alias == 'Detecção de Capacete' || newAnalytic.alias == 'Detecção de Máscara'))}">
                        <div class="card">
                            <div class="card-header card-config-analy">
                                <div class="row containerTitle">
                                    <span class="TitleInterval">Criticidade do alerta</span>
                                </div>
                                <app-filter [list]="criticalityOptions" type="simple" placeholder="Selecione aqui..."
                                    (filterStatusChange)="changeCriticalityFilter($event)" [showSelected]="true" [analytic]="true"
                                    [styles]="['simple-alternate-style']" [hasIconPrefix]="false" [hasToggle]="true" [selected]="criticalitySelected">
                                </app-filter>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row card-row" *ngIf="newAnalytic.alias == 'Aglomeração e dispersão'">
        <div class="card-fifty aglomeration-max card-info" style="padding-right:0;">
            <div class="card small-card">
                <div class="card-header card-config-analy">
                    <span class="TitleInterval">Alertar a partir de</span>
                    <div class="input-time" style="flex-direction: row;">
                        <div class="flex mb-2 min">
                            <input class="style-input-time input-max-time" type="text"
                            [formControl]="crowdingMaxTimeMin" mask="s0" placeholder="0">
                            <span class="style-title-alertas time-label">Min</span>
                        </div>
                        <div class="flex sec">
                            <input class="style-input-time input-max-time" type="text"
                            [formControl]="crowdingMaxTimeSec" mask="s0" placeholder="0">
                            <span class="style-title-alertas time-label">Seg</span>
                        </div>
                    </div>
                    <mat-error *ngIf="crowdingMaxTimeMin.value == 0 && crowdingMaxTimeSec.value == 0
                    && (crowdingMaxTimeMin.touched || crowdingMaxTimeSec.touched)"
                    style="color: var(--error-red)">
                        Defina um valor <strong>maior que zero</strong>
                    </mat-error>
                </div>
            </div>
        </div>
        <div class="card-fifty criticality-card card-info" style="padding-right:0; padding-left:14px;">
            <div class="card">
                <div class="card-header card-config-analy">
                    <div class="row containerTitle">
                        <span class="TitleInterval">Criticidade do alerta</span>
                    </div>
                    <app-filter [list]="criticalityOptions" type="simple" placeholder="Selecione aqui..."
                        (filterStatusChange)="changeCriticalityFilter($event)" [showSelected]="true" [analytic]="true"
                        [styles]="['simple-alternate-style']" [hasIconPrefix]="false" [hasToggle]="true" [selected]="criticalitySelected">
                    </app-filter>
                </div>
            </div>
        </div>
    </div>
    <div class="row card-row">
        <div>
            <div class="card" style="height: 100% !important;">
                <div class="card-header card-config-analy" style="margin-top: 0;">
                    <div class="container_detection_interval">
                        <div class="containerTitleInterval">
                            <span class="TitleInterval">Intervalo de detecção</span>
                            <div *ngIf="isHolidayActive" class="holiday-calendar-list-button" (click)="openHolidayView()">
                                <span nz-icon nzType="calendar" nzTheme="outline" style="font-size: 14px; margin-right: 3px;"></span>
                                Calendário De Feriados habilitados
                            </div>
                        </div>
                        <div style="display: flex; margin-left: 10px; ">
                            <nz-radio-group>
                                <div class="detec-interval">
                                    <div class="col-6 col-md-3" style="margin-right: 22px">
                                        <label style="white-space: nowrap;" nz-radio class="radio_button_position" [nzValue]="1" (click)="getTimeSchedule(1)" [ngModel]="selectedComercial">Horário comercial</label>
                                        <div *ngIf="idSchedule == 1" class="row radio_button_position margin_radiobutton_Text">
                                            <span class="time_information">Dias úteis de 08:00h às 18:00h</span>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-3" style="margin-right: 15px">
                                        <label style="white-space: nowrap;" nz-radio class="radio_button_position" [nzValue]="2" (click)="getTimeSchedule(2)" [ngModel]="selectedNight">Período noturno</label>
                                        <div *ngIf="idSchedule == 2" class="row radio_button_position margin_radiobutton_Text">
                                            <span class="time_information">Dias úteis de 18:00h às 06:00h do dia seguinte</span>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-3">
                                        <label style="white-space: nowrap;" nz-radio class="radio_button_position" [nzValue]="3" (click)="getTimeSchedule(3)" [ngModel]="selectedOthers">Escolher os dias e horários</label>
                                    </div>
                                </div>
                            </nz-radio-group>
                        </div>
                    </div>
                    <div *ngIf="idSchedule == 3">
                        <div class="card custom-card card_analitics_days">
                            <span (click)="getSchedule()" *ngIf="!loadingLastSchedules; else loadingLastSchedule"
                                class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xga-12 col-fhd-12 mr-auto returnOldRegister"
                                [ngClass]="hideButton ? 'hide' : ''">
                                Preencher com último registro</span>
                            <ng-template #loadingLastSchedule>
                                <span nz-icon class="spinner_last_schedule" nzType="loading" nzTheme="outline" style="font-size: 36px"></span>
                            </ng-template>
                            <div class="row row_schedule_days">
                                <div *ngFor="let selectDay of weekList; let i=index"
                                    class="col-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 col-xga-1 col-fhd-1 schedules_days_container">
                                    <label class="form-check-label"
                                        [ngStyle]="{'color':changeColorHtml(selectDay.active), 'font-weight':changeWeightHtml(selectDay.active)}">
                                        <input class="form-check-input" type="checkbox" [checked]="selectDay.active"
                                            [ngStyle]="{'background-color': changeBackgroundHtml(selectDay.active)}"
                                            (change)="changeCheckHtml(selectDay.day)" [formControl]="selectedDays">
                                        {{selectDay.day}}
                                        <span class="form-check-sign">
                                            <span class="check"></span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <span class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xga-6 col-fhd-6 mr-auto style-title-alertas title_alerts">
                                Alertar entre os horários
                            </span>
                            <div class="flex container_Schedules">
                                <div class="hour-container">
                                    <nz-input-group nzCompact>
                                        <input type="text" nz-input #initialTime class="time-begin input-date-style" disabled
                                        placeholder="Selecionar hora" [formControl]="timeBegin" name="beginTime" />
                                        <input
                                            type="text"
                                            disabled
                                            nz-input
                                            placeholder="-"
                                            style="width: 30px; height: 40px; border-left: 0px; border-right: 0px; pointer-events: none; background-color: rgb(255, 255, 255);"
                                            class="input-date-style input-date-style-mid"
                                        />
                                        <input type="text" nz-input  #finalTime class="time-end input-date-style" disabled
                                        mask="Hh:m0" placeholder="Selecionar hora" [formControl]="timeEnd" name="endTime" [showMaskTyped]="false" [dropSpecialCharacters]="false" />
                                        <div class="time-range-picker">
                                            <app-time-range-picker (changeTime)="getTime($event)"
                                                [time]="[timeBegin, timeEnd]"
                                                [calendarSelect]="true">
                                            </app-time-range-picker>
                                        </div>
                                    </nz-input-group>
                                    <div class="flex items-center">
                                        <input class="form-check-input" type="checkbox" [formControl]="selectAllDays">
                                        <span class="font_title_style">24 horas</span>
                                    </div>
                                </div>
                                <div style="width: 22%;">
                                    <button (click)="addSchedule()" type="button"
                                        class="style-button-add-schedule">
                                        <i nz-icon nzType="plus" nzTheme="outline"></i> Adicionar</button>
                                </div>
                            </div>
                        </div>
                        <div class="row overflow_container" [ngStyle]="{'height': '100%', 'margin-top': '8px'}">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xga-12 col-fhd-12">
                                <nz-table #basicTable [nzData]="weekList" [nzShowPagination]="false"
                                        [nzSize]="'middle'" [nzTableLayout]="'auto'" class="table style-table">
                                    <thead>
                                    <tr *ngIf="false">
                                        <th class="style-title-table">Dia</th>
                                        <th class="style-title-table">Receber alertas entre</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let data of basicTable.data; index as i">
                                        <td class="style-column-letter-table">{{weekList[i].day}} </td>
                                        <td style="width: 90%; padding: 0">
                                            <span class="schedule-week" *ngFor="let s of data.schedules"
                                                (mouseover)="s.close = true" (mouseout)="s.close = false">
                                                <div class="concat-time">
                                                    <div class="time-tag-wrapper">
                                                        {{s.concatTime}}
                                                        <span [hidden]="!s.close" class="inner-button" (click)="removeSchedule(s)">
                                                            <i nz-icon nzType="close"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </nz-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="button-sec">
    <div class="row_bottom">
        <button (click)="cancelEmit.emit()" type="button" style="margin: 5px;"
                class="btn btn-md btn-default tamButton button-clean">Cancelar</button>
        <button (click)="saveEmit.emit()" type="button" style="margin: 5px;"
                [disabled]="loading || (crowdingMaxTimeMin.value == 0 && crowdingMaxTimeSec.value == 0
                && ['Aglomeração', 'Ausência de Movimento', 'Abandono de Posto',
                'Tampering', 'Detecção de Emboscada', 'Vadiagem', 'Abuso de Permanência', 'Dispersão',
                'Aglomeração e dispersão'].includes(selectAnalytics.value['alias']))"
                class="btn btn-md btn-primary tamButton button_save_permission">Salvar
                <i nz-icon nzType="loading" class="loading-icon" nzTheme="outline" *ngIf="loading"></i>
        </button>
    </div>
</div>
<app-modal></app-modal>
